/* eslint-disable max-len */
export default {
  Contact: {
    Title: 'Contact',


    FirstName: {
      Label: 'First Name *',
    },
    LastName: {
      Label: 'Last Name *',
    },
    Email: {
      Label: 'Email Address *',
    },
    PhoneNumber: {
      Label: 'Phone number *',
    },
    StreetAddress: {
      Label: 'Street Address *',
    },
    City: {
      Label: 'City *',
    },
    Province: {
      Label: 'Province/Territory *',
      List: {
        AB: 'Alberta',
        BC: 'British Columbia',
        MB: 'Manitoba',
        NB: 'New Brunswick',
        NL: 'Newfoundland and Labrador',
        NS: 'Nova Scotia',
        NT: 'Northwest Territories',
        NU: 'Nunavut',
        ON: 'Ontario',
        PE: 'Prince Edward Island',
        QC: 'Quebec',
        SK: 'Saskatchewan',
        YT: 'Yukon',
      },
    },
    PostalCode: {
      Label: 'Postal Code *',
    },

    Missing: {
      FullName: 'Name has not been provided yet.',
      Email: 'Email address has not been added yet.',
      PhoneNumber: 'Phone number has not been added yet.',
      Address: 'Mailing address has not been provided yet.',
    },
  },

  Profile: {
    Title: 'Profile',

    ShortBio: 'Short bio',
    PersonalBio: 'Personal bio',
    CaregiverMotivation: 'Caregiver motivation',
    ProfilePhoto: 'Profile photo',
    UploadFile: 'Drop or browser new files',

    Missing: {
      ShortBio: 'Short bio has not been written yet.',
      PersonalBio: 'Personal bio has not been provided yet.',
      CaregiverMotivation: 'Caregiver motivation has not been described yet.',
      ProfilePhoto: 'No profile photo has been uploaded yet.',
    },
  },

  Languages: {
    Title: 'Languages',

    LanguagesOther: {
      Title: 'Language',
      Placeholder: 'e.g., Urdu',
    },
    AddLanguageButton: 'Add Language',
    FluencyHelpText: 'Select the fluency level',
    LanguagesSelectedCount: 'Languages Selected (#{count}):',
    RemoveLanguageButton: 'Remove Language',

    Action: {
      Remove: 'Remove',
      Add: 'Add',
    },

    AvailableLanguages: {
      English: 'English',
      French: 'French',
      Mandarin: 'Mandarin',
      Cantonese: 'Cantonese',
      Hindustani: 'Hindustani',
      Spanish: 'Spanish',
      Punjabi: 'Punjabi',
      Arabic: 'Arabic',
      Tagalog: 'Tagalog',
      Italian: 'Italian',
      German: 'German',
      Portuguese: 'Portuguese',
      Persian: 'Persian',
      Russian: 'Russian',
      Tamil: 'Tamil',
      Vietnamese: 'Vietnamese',
      Gujarati: 'Gujarati',
      Polish: 'Polish',
      Korean: 'Korean',
      SerboCroatian: 'Serbo-Croatian',
      Greek: 'Greek',
      HaitianCreole: 'Haitian Creole',
      Ukrainian: 'Ukrainian',
      Bengali: 'Bengali',
      Romanian: 'Romanian',
      Dutch: 'Dutch',
      Cree: 'Cree',
      Japanese: 'Japanese',
      Hebrew: 'Hebrew',
      Turkish: 'Turkish',
      Malayalam: 'Malayalam',
      Hungarian: 'Hungarian',
      Ilocano: 'Ilocano',
      Somali: 'Somali',
      Swahili: 'Swahili',
      Telugu: 'Telugu',
      Other: 'Other Language',
    },
    Fluency: {
      Basic: 'Basic',
      Conversational: 'Conversational',
      Fluent: 'Fluent',
      Native: 'Native',
    },

    EmptyState: 'No languages have been added yet.',
  },

  Certificate: {
    Title: 'Professional Certifications/Licenses',

    AvailableCertifications: {
      PSW: 'Personal Support Worker (PSW)',
      DSW: 'Developmental Service Worker (DSW)',
      PAB: 'Préposé aux bénéficiaires (PAB)',
      CNA: 'Certified Nursing Assistant (CNA)',
      HCA: 'Health Care Aide (HCA)',
      RNA: 'Registered Nursing Assistant (RNA)',
      RPN: 'Registered Practical Nurse (RPN)',
      RN: 'Registered Nurse (RN)',
      CSW: 'Community Service Worker',
      SSW: 'Social Service Worker',
      CPR: 'CPR Certification',
      FIRST_AID: 'First Aid Certification',
      PSW_STUDENT: 'PSW Student',
      NURSING_STUDENT: 'Nursing Student',
    },

    IssuingOrgOrSchool: {
      Label: 'Issuing Organization/School *',
      Placeholder: 'e.g., George Brown College',
    },

    City: {
      Label: 'City *',
      Placeholder: 'e.g. Toronto',
    },

    DateObtained: {
      Label: 'Date Obtained *',
      Placeholder: 'YYYY-MM',
    },

    EmptyState: 'No certifications have been recorded yet.',

    SelectedCount: 'Certitficates Selected (#{count}):',

    Attachments: 'Attachments',
    HideAttachments: 'Hide attachments',
    ShowAttachments: 'Show attachments',
  },

  WorkHistory: {
    Title: 'Work History',
    Subtitle: 'Tell us about your previous work experience.',
    EmploymentLabel: 'Employment #{number}',
    Employer: {
      Label: 'Employer Name',
      Placeholder: 'Name of the company or organization',
    },
    StartDate: {
      Label: 'Start Date',
      Placeholder: 'YYYY-MM',
    },
    EndDate: {
      Label: 'End Date',
      Placeholder: 'Leave blank if currently employed',
    },
    CanContact: {
      Label: 'This employer can be contacted as a reference',
    },
    ReferenceContactInfo: {
      Label: 'Reference Contact Information',
      Placeholder: 'e.g., Phone: (555) 123-4567, Email: manager@company.com',
    },

    AddEmployerButton: 'Add Employment',

    Summary: {
      Title: 'Employment History Summary (#{count} #{positions}):',
      PositionSingular: 'position',
      PositionPlural: 'positions',
      UnnamedEmployer: 'Unnamed Employer',
      ReferenceAvailable: 'Reference: ',
      DatesNotSpecified: 'Dates not specified',
      UntilDate: 'Until #{date}',
      Present: 'Present',
    },

    EmptyState: 'No employment history has been added yet.',
  },

  VulnerableSectorCheck: {
    Title: 'Vulnerable Sector Check',
    HasCheck: 'Has Vulnerable Sector Check',
    HasBeenVerified: 'Has Been Verified',
    Documents: 'Uploaded Documents',
    EmptyState: 'No documents have been uploaded yet.',
    UploadTitle: 'Upload Supporting Documents',
    UploadDescription: 'Drop files or click to upload the latest vulnerable sector check.',
    HideAttachments: 'Hide attachments',
    ShowAttachments: 'Show attachments',
  },

  Agreement: {
    Title: 'Agreements & Declarations',
    Subtitle: 'Please review each statement below and confirm the items that apply to you.',
    Questions: {
      TermsAgreement: {
        Title: 'I agree to the platform terms and conditions',
        Subtitle: 'I have reviewed the caregiver platform terms of service and privacy policy and I accept them.',
      },
      CertifiesTruthfulness: {
        Title: 'I certify that the information I have provided is truthful',
        Subtitle: 'All details submitted in my application are accurate to the best of my knowledge.',
      },
      UnderstandsPrivacyAndAgreesToConfidentialityPolicies: {
        Title: 'I understand and will uphold privacy and confidentiality policies',
        Subtitle: 'I agree to protect client information and comply with all confidentiality requirements.',
      },
      CertifiesValidAndUpToDateCertifications: {
        Title: 'My licences and certifications are valid and up to date',
        Subtitle: 'Every qualification or certificate I have listed remains current and can be verified.',
      },
      UnderstandsAbuseProhibition: {
        Title: 'I understand that abuse, neglect, or exploitation is strictly prohibited',
        Subtitle: 'I acknowledge that any abusive behaviour toward clients is forbidden and grounds for removal.',
      },
      CommittedToCodeOfConductAndEthics: {
        Title: 'I commit to following the organization\'s code of conduct and ethics',
        Subtitle: 'I will uphold our standards in every interaction with clients, families, and fellow team members.',
      },
    },
    Summary: {
      Confirmed: 'Confirmed',
      Pending: 'Pending confirmation',
    },
    EmptyState: 'No agreement responses have been recorded yet.',
  },
};
